import utils, { STORE } from '@os-plugins/util.js';
export const state = () => ({
  data:{}
})

export const mutations = {
  init(state,data){
		state.data = data;
	}
}

export const actions = {
  init({commit},{data={}}){

		//格式化时间
		data._appointTimes = STORE.formatDates(data.appointTimes||[]);
		data._takeSelfTimes = STORE.formatDates(data.takeSelfTimes||[]);
		
		commit('init',data);
	}

}



// WEBPACK FOOTER //
// ./../../store/booking/store.js